
export const subsidies = {
  'subsidies.title': 'Résultats de Subventions',
  'subsidies.subtitle': 'Subventions disponibles correspondant au profil de votre ferme',
  'subsidies.matchConfidence': 'Confiance de Correspondance',
  'subsidies.deadline': 'Date Limite',
  'subsidies.regionEligibility': 'Éligibilité Régionale',
  'subsidies.grantCode': 'Code de Subvention',
  'subsidies.maxGrant': 'Subvention Maximale',
  'subsidies.draftDate': 'Date du Brouillon',
  'subsidies.status': 'Statut',
  'subsidies.reminder': 'Rappel',
  'subsidies.searchEngine': 'Moteur de Recherche de Subventions Européennes',
  'subsidies.fundingType': 'Type de Financement',
  'subsidies.countryEligibility': 'Éligibilité par Pays',
  'subsidies.agriculturalSector': 'Secteur Agricole',
  'subsidies.farmingMethod': 'Méthode Agricole',
  'subsidies.grantValue': 'Valeur de la Subvention',
  'subsidies.certifications': 'Certifications',
  'subsidies.matchConfidenceSlider': 'Confiance de Correspondance',
  'subsidies.resultsFound': 'subventions trouvées pour vos critères',
  'subsidies.noMatchCriteria': 'Aucune subvention ne correspond à vos critères.',
  'subsidies.public': 'Public',
  'subsidies.private': 'Privé',
  'subsidies.mixed': 'Mixte',
  'subsidies.attachToFarm': 'Attacher à la Ferme',
  'subsidies.selectFarm': 'Sélectionner une Ferme pour l\'Attachement',
  'subsidies.noSubsidies': 'Aucune Subvention Disponible',
  'subsidies.viewDetails': 'Voir les Détails',
  'subsidies.eligibilityCriteria': 'Critères d\'Éligibilité',
  'subsidies.apply': 'Postuler',
  'subsidies.importFromPortal': 'Importer du Portail',
  'subsidies.region': 'Région',
  'subsidies.matchScore': 'Score de Correspondance',
  'subsidies.searchResults': 'Résultats de recherche',
  'subsidies.noSubsidiesFound': 'Aucune Subvention Trouvée',
  'subsidies.noSubsidiesFoundDesc': 'Aucune subvention correspondant à vos critères n\'a été trouvée',
  'subsidies.filters': 'Filtres',
  'subsidies.sortByLabel': 'Trier par',
  'subsidies.fundingType.public': 'Public',
  'subsidies.fundingType.private': 'Privé',
  'subsidies.fundingType.mixed': 'Mixte',
  'subsidies.fundingTypePublic': 'Public',
  'subsidies.fundingTypePrivate': 'Privé',
  'subsidies.fundingTypeMixed': 'Mixte',
  'subsidies.searchSubsidies': 'Rechercher des Subventions',
  'subsidies.findAvailableSubsidies': 'Trouvez des subventions disponibles pour vos fermes',
  'subsidies.currentlyAvailable': 'Actuellement {count} subventions disponibles',
  'subsidies.viewAttached': 'Voir les Subventions Attachées',
  'search.actions.attached': 'Attaché',
  'search.actions.attach': 'Attacher à une Ferme',
  
  // Funding amount display
  'subsidies.funding.loanContactTerms': 'Prêt - Contacter pour les modalités',
  'subsidies.funding.technicalAssistance': 'Assistance technique fournie',
  'subsidies.funding.grantAmountPerProject': 'Subvention - Montant déterminé par projet',
  'subsidies.funding.financialAidVaries': 'Aide financière - Montant variable',
  'subsidies.funding.recoverableAdvance': 'Avance récupérable - Modalités variables',
  'subsidies.funding.grantCaseByCase': 'Subvention - Évalué au cas par cas',
  'subsidies.funding.contactForDetails': 'Contacter pour les détails du financement',
  'subsidies.funding.variableByProject': 'Variable selon projet',
  'subsidies.funding.loanAvailable': 'Prêt disponible - {amount} €',
  'subsidies.funding.contactWithAidType': '{aidType} - Contacter pour les détails',
  
  // Search results headers
  'subsidies.availableFundingOpportunities': 'Opportunités de Financement Disponibles',
  'subsidies.sortBy': 'Trier par',
  // Missing French translations for sort options
  'subsidies.sortBy.default': 'Par défaut',
  'subsidies.sortBy.relevance': 'Meilleure correspondance',
  'subsidies.sortBy.amountHigh': 'Décroissant',
  'subsidies.sortBy.amountLow': 'Croissant',
  'subsidies.sortBy.deadlineLeast': 'Échéance la plus proche',
  'subsidies.sortBy.deadlineMost': 'Échéance la plus lointaine',
  'subsidies.sortBy.newest': 'Plus récent',
  'subsidies.sortBy.oldest': 'Plus ancien',
  // Additional subsidy display keys
  'subsidies.applicationClosed': 'Candidature fermée',
  'subsidies.daysLeft': 'j',
  'subsidies.upTo': 'Jusqu\'à',
  'subsidies.from': 'À partir de',

  // Search filters (matching English structure)
  'search.filters.title': 'Affiner les résultats',
  'search.filters.geographicEligibility': 'Éligibilité géographique',
  'search.filters.region': 'Région',
  'search.filters.frenchRegions': 'Régions françaises',
  'search.filters.noRegionsAvailable': 'Aucune région disponible',
  'search.filters.eligibleCountry': 'Pays éligible',

  'search.filters.sector': 'Secteur',
  'search.filters.activitySectors': 'Secteurs d\'activité',
  'search.filters.noSectorsAvailable': 'Aucun secteur disponible',

  'search.filters.agriculturalSector': 'Secteur agricole',
  'search.filters.farmingType': 'Type d\'agriculture',
  'search.filters.farmingType.arableCrops': 'Grandes cultures',
  'search.filters.farmingType.vineyards': 'Vignobles',
  'search.filters.farmingType.livestock': 'Élevage',
  'search.filters.farmingType.aquaculture': 'Aquaculture',
  'search.filters.farmingType.mixedFarming': 'Polyculture-élevage',
  'search.filters.farmingType.greenhouse': 'Serres / Agriculture verticale',

  'search.filters.fundingType': 'Dispositifs',
  'search.filters.fundingTypes': 'Dispositifs de financement',
  'search.filters.noTypesAvailable': 'Aucun dispositif disponible',
  'search.filters.fundingSource': 'Source de financement',
  'search.filters.fundingSource.public': 'Public (UE, National)',
  'search.filters.fundingSource.private': 'Privé (Banque, VC)',
  'search.filters.fundingSource.hybrid': 'Hybride (Public-Privé)',
  'search.filters.fundingInstrument': 'Instrument de financement',
  'search.filters.fundingInstrument.grant': 'Subvention',
  'search.filters.fundingInstrument.subsidy': 'Aide',
  'search.filters.fundingInstrument.taxCredit': 'Crédit d\'impôt',
  'search.filters.fundingInstrument.loan': 'Prêt',
  'search.filters.fundingInstrument.technicalAssistance': 'Assistance technique',

  'search.filters.applicationRequirements': 'Exigences de candidature',
  'search.filters.documentsRequired': 'Documents requis',
  'search.filters.documentsRequired.businessPlan': 'Plan d\'affaires',
  'search.filters.documentsRequired.sustainabilityReport': 'Rapport de durabilité',
  'search.filters.documentsRequired.carbonAssessment': 'Bilan carbone',
  'search.filters.documentsRequired.euFarmId': 'Identifiant agricole UE',
  'search.filters.documentsRequired.digitalCertification': 'Certification numérique',
  'search.filters.documentsRequired.previousGrantRecord': 'Historique de subventions',
  'search.filters.applicationFormat': 'Format de candidature',
  'search.filters.applicationFormat.online': 'En ligne',
  'search.filters.applicationFormat.pdf': 'PDF',
  'search.filters.applicationFormat.portal': 'Via portail',
  'search.filters.applicationFormat.consultant': 'Avec consultant uniquement',

  'search.filters.strategicAlignment': 'Alignement stratégique',
  'search.filters.sustainabilityGoals': 'Objectifs de durabilité',
  'search.filters.sustainabilityGoals.organicTransition': 'Transition bio',
  'search.filters.sustainabilityGoals.waterEfficiency': 'Efficacité hydrique',
  'search.filters.sustainabilityGoals.emissionReduction': 'Réduction des émissions',
  'search.filters.sustainabilityGoals.soilHealth': 'Santé des sols',
  'search.filters.sustainabilityGoals.biodiversity': 'Biodiversité',
  'search.filters.sustainabilityGoals.climateAdaptation': 'Adaptation climatique',

  'search.filters.amount': 'Montant',
  'search.filters.fundingAmount': 'Montant du financement',
  'search.filters.organization': 'Organisme',
  'search.filters.fundingOrganizations': 'Organismes de financement',
  'search.filters.noOrganizationsAvailable': 'Aucun organisme disponible',
  'search.filters.deadlineStatus': 'Statut de l\'échéance',
  'search.filters.deadline': 'Échéance',
  'search.filters.deadlinePeriod': 'Période d\'échéance',
  'search.filters.deadline.open': 'Ouvert',
  'search.filters.deadline.closingSoon': 'Fermeture prochaine (30 jours)',
  'search.filters.deadline.closed': 'Fermé (archive)',
  'search.filters.openNow': 'Ouvert actuellement',
  'search.filters.closingSoon30Days': 'Fermeture dans 30 jours',
  'search.filters.closing30to90Days': 'Fermeture dans 30-90 jours',
  'search.filters.permanent': 'Permanent',

  'search.filters.noMatches': 'Aucune aide ne correspond. Élargissez vos critères.',
  'search.filters.saveFilterSet': 'Enregistrer les filtres',
  'search.filters.savedFilters': 'Filtres sauvegardés',
  'search.filters.enterFilterSetName': 'Nom pour cet ensemble de filtres',
  'search.filters.save': 'Enregistrer',
  'search.filters.cancel': 'Annuler',

  // Search Page UI
  'search.placeholder': 'Rechercher des opportunités de financement...',
  'search.button': 'Rechercher',
  'search.popularSearches': 'Recherches populaires :',
  'search.smartFilters': 'Filtres Intelligents',
  'search.findIdealMatch': 'Trouvez le financement idéal',
  'search.popularCombinations': 'Combinaisons populaires :',
  'search.searchAndFilterOptions': 'Recherche et filtres',
  'search.yourSavedSearches': 'Vos recherches sauvegardées',
  'search.saveFilters': 'Enregistrer les filtres',
  'search.noSavedFilters': 'Aucun filtre sauvegardé',
  'search.locationEligibility': 'Localisation et éligibilité',
  'search.frenchRegions': 'Régions françaises',
  'search.countryTerritory': 'Pays/Territoire',
  'search.enterCountry': 'Entrez votre pays (France, UE, etc.)',
  'search.businessSector': 'Entreprise et secteur',
  'search.activitySector': 'Secteur d\'activité',
  'search.fundingDetails': 'Détails du financement',
  'search.typeOfFunding': 'Type de financement',
  'search.applicationStatus': 'Statut de candidature',
  'search.currentlyOpen': 'Ouvert actuellement',
  'search.closingSoon': 'Fermeture prochaine',
  'search.recentlyAdded': 'Récemment ajouté',
  'search.highSuccessRate': 'Taux de succès élevé',
  'search.fundingOrganizations': 'Organismes de financement',
  'search.majorFunders': 'Principaux financeurs',
  'search.otherOrganizations': 'Autres organisations',
  'search.fundingAmount': 'Montant du financement',
  'search.expectedAmountRange': 'Fourchette de montant',
  'search.amountFilteringUnavailable': 'Filtre de montant temporairement indisponible - toutes les aides affichées.',
  'search.applicationRequirements': 'Exigences de candidature',
  'search.farmGoalsSustainability': 'Objectifs agricoles et durabilité',
  'search.applicationTimeline': 'Calendrier de candidature',

  // Update timestamps
  'search.recentlyUpdated': 'Mis à jour récemment',
  'search.updatedJustNow': 'Mis à jour à l\'instant',
  'search.updatedHoursAgo': 'Mis à jour il y a {hours} heures',
  'search.updatedYesterday': 'Mis à jour hier',
  'search.updatedDaysAgo': 'Mis à jour il y a {days} jours',
  'search.updatedOn': 'Mis à jour le {date}',

  // EmptySubsidyState
  'search.empty.noSubsidiesAvailable': 'Aucune Subvention Disponible',
  'search.empty.noSubsidiesDescription': 'Aucune subvention n\'est actuellement disponible dans la base de données. Revenez plus tard pour de nouvelles opportunités.',
  'search.empty.noMatchingSubsidies': 'Aucune Subvention Correspondante',
  'search.empty.noMatchingDescription': 'Aucune subvention ne correspond à votre recherche pour "{query}" et aux filtres actuels.',
  'search.empty.noMatchingFiltersDescription': 'Aucune subvention ne correspond à vos critères de filtre actuels.',
  'search.empty.clearAllFilters': 'Effacer Tous les Filtres',
  'search.empty.errorLoadingSubsidies': 'Erreur de Chargement des Subventions',
  'search.empty.errorDescription': 'Impossible de charger les données de subvention. Veuillez réessayer.',
  'search.empty.tryAgain': 'Réessayer',
  'search.empty.noResults': 'Aucun Résultat',
  'search.empty.noResultsDescription': 'Aucun résultat à afficher.',

  // SmartFilterSuggestions
  'search.smartSuggestions.title': 'Suggestions de Filtres Intelligents',
  'search.smartSuggestions.popularFilters': 'Filtres populaires que d\'autres utilisateurs trouvent utiles :',
  'search.smartSuggestions.unproductiveWarning': 'Filtres improductifs détectés',
  'search.smartSuggestions.unproductiveDescription': 'Ces filtres ne renvoient généralement aucun résultat : {filters}',
  'search.smartSuggestions.uses': '{count} utilisations',

  // SearchResultsPanel
  'search.results.currentlyAvailable': 'Actuellement {count} subventions disponibles',
  'search.results.recentlyClosed': 'Récemment Fermées ({count})',
  'search.results.relaxedSearch': 'Nous avons assoupli votre recherche en raison de caractères spéciaux. Affichage des résultats pour "{query}".',

  // SavedFilterSets
  'search.savedFilters.applyFilters': 'Appliquer les Filtres',
  'search.savedFilters.filtersCount': '{count} filtres',

  // SubsidyFilters
  'search.filters.active': 'actif',
  'search.filters.clearAll': 'Tout Effacer',

  // OrganizationFilter
  'search.filters.moreOrganizations': '+{count} organisations supplémentaires',
  'search.filters.loadingOrganizations': 'Chargement des organisations...',

  // AmountRangeFilter - Fallback ranges
  'search.filters.amountRange.lessThan10k': 'Moins de 10 000 €',
  'search.filters.amountRange.10kTo50k': '10 000 € - 50 000 €',
  'search.filters.amountRange.50kTo100k': '50 000 € - 100 000 €',
  'search.filters.amountRange.100kTo500k': '100 000 € - 500 000 €',
  'search.filters.amountRange.moreThan500k': 'Plus de 500 000 €',

  // GeographicEligibilityFilter
  'search.filters.moreRegions': '+{count} régions supplémentaires',

  // RecommendedSection
  'search.recommended.title': 'Recommandé pour Vous',
  'search.recommended.loading': 'Chargement...',
  'search.recommended.noRecommendations': 'Aucune recommandation personnalisée disponible',
  'search.recommended.noRecommendationsWithQuery': 'Aucune recommandation personnalisée ne correspond à "{query}"',

  // Subsidy Detail Page UI Elements
  'detail.back': 'Retour',
  'detail.backToDiscovery': 'Découvrir',
  'detail.backToSearch': 'Recherche',
  'detail.subsidyNotFound': 'Subvention Non Trouvée',
  'detail.subsidyNotFoundDesc': 'La subvention demandée n\'a pas pu être trouvée.',
  'detail.deadline': 'Date limite',

  // Tab navigation (consolidated 4 tabs)
  'detail.tabs.overview': 'Aperçu',
  'detail.tabs.conditions': 'Conditions',
  'detail.tabs.candidature': 'Candidature',
  'detail.tabs.contact': 'Contact',
  // Legacy tab keys (kept for backwards compatibility)
  'detail.tabs.eligibility': 'Éligibilité',
  'detail.tabs.financial': 'Financement',
  'detail.tabs.requirements': 'Exigences',
  'detail.tabs.process': 'Processus',
  'detail.tabs.legal': 'Aspects Juridiques',
  'detail.tabs.administrative': 'Démarches Administratives',
  'detail.tabs.documents': 'Documents',

  // Overview section
  'detail.overview.subsidyDetails': 'Détails de la Subvention',
  'detail.overview.description': 'Description',
  'detail.overview.aiSummary': 'En bref',

  // Fiscal subsidy details
  'detail.fiscal.title': 'Avantage Fiscal',
  'detail.fiscal.rate': 'Taux de réduction',
  'detail.fiscal.reductionRate': 'Taux de réduction',
  'detail.fiscal.taxTypes': 'Impôts concernés',
  'detail.fiscal.applicableTaxes': 'Impôts applicables',
  'detail.fiscal.legalReferences': 'Références légales',
  'detail.fiscal.creditDescription': 'du montant éligible',
  'detail.fiscal.exonerationDescription': "de réduction d'impôt",

  // Contact extras
  'detail.contact.additionalInfo': 'Informations complémentaires',
  'detail.overview.geographicEligibility': 'Éligibilité Géographique',
  'detail.overview.nationalCoverage': 'Couverture Nationale',
  'detail.overview.regions': 'Régions',
  'detail.overview.departments': 'Départements',
  'detail.overview.programFocus': 'Objectifs du Programme',
  'detail.overview.targetSectors': 'Secteurs Ciblés',
  'detail.overview.eligibleApplicants': 'Demandeurs Éligibles',
  'detail.overview.eligibleUses': 'Utilisations Éligibles',
  'detail.overview.keyRequirements': 'Exigences Clés',
  'detail.overview.availability': 'Disponibilité',
  'detail.overview.helpfulTips': 'Conseils Utiles',
  'detail.overview.detailedInfo': 'Informations détaillées',
  'detail.overview.moreEligibleUses': 'Et {count} autres utilisations éligibles...',
  'detail.overview.moreRequirements': 'Et {count} autres exigences...',
  'detail.overview.moreRegions': '+{count} de plus',
  'detail.overview.eligibleExpenses': 'Dépenses éligibles',
  'detail.overview.programContext': 'Contexte du programme',
  'detail.overview.applicationTiming': 'Période de candidature',

  // Eligibility section
  'detail.eligibility.title': 'Critères d\'Éligibilité',
  'detail.eligibility.detailedCriteria': 'Critères d\'éligibilité détaillés',
  'detail.eligibility.targetAudiences': 'Public Cible',
  'detail.eligibility.eligibleLegalEntities': 'Entités Légales Éligibles',
  'detail.eligibility.keyRequirements': 'Exigences Principales',
  'detail.eligibility.restrictions': 'Restrictions',
  'detail.eligibility.notAvailable': 'Les critères d\'éligibilité détaillés ne sont pas disponibles',
  'detail.eligibility.contactAgency': 'Contactez l\'organisme pour les exigences spécifiques',

  // Financial section
  'detail.financial.title': 'Détails Financiers',
  'detail.financial.detailedFinancial': 'Informations financières détaillées',
  'detail.financial.fundingAmount': 'Montant du Financement',
  'detail.financial.grantDetails': 'Détails de la Subvention',
  'detail.financial.loanOption': 'Option de Prêt',
  'detail.financial.recoverableAdvance': 'Avance Récupérable',
  'detail.financial.coFinancingRate': 'Taux de Cofinancement',
  'detail.financial.fundingDetails': 'Détails du Financement',
  'detail.financial.upTo': 'Jusqu\'à',
  'detail.financial.from': 'À partir de',
  'detail.financial.nonRepayableGrant': 'Subvention non remboursable',
  'detail.financial.repayableLoan': 'Prêt remboursable',
  'detail.financial.conditionalRepayment': 'Remboursement conditionnel',
  'detail.financial.maxPercentageCovered': 'Pourcentage maximum des coûts du projet couverts',

  // Contact section
  'detail.contact.title': 'Informations de Contact',
  'detail.contact.contactsAdmin': 'Contacts et processus administratif',
  'detail.contact.contactOrganization': 'Organisation de Contact',
  'detail.contact.contactInfo': 'Informations de Contact',
  'detail.contact.service': 'Service',
  'detail.contact.contact': 'Contact',
  'detail.contact.notAvailable': 'Informations de contact non disponibles',
  'detail.contact.agency': 'Organisme',
  'detail.contact.organization': 'Organisation',
  'detail.contact.contactPerson': 'Personne de contact',
  'detail.contact.phone': 'Téléphone',
  'detail.contact.email': 'E-mail',
  'detail.contact.website': 'Site web',
  'detail.contact.address': 'Adresse',
  'detail.contact.noContactInfo': 'Aucune information de contact disponible',

  // Sidebar
  'detail.sidebar.assignToProfiles': 'Assigner à un Profil',
  'detail.sidebar.assignedProfiles': 'Profils Assignés ({count})',
  'detail.sidebar.assignToProfile': 'Ajouter à un profil',
  'detail.sidebar.selectProfilesToAssign': 'Sélectionnez les profils à assigner',
  'detail.sidebar.loadingProfiles': 'Chargement des profils...',
  'detail.sidebar.noProfilesFound': 'Aucun profil trouvé. Créez d\'abord un profil.',
  'detail.sidebar.alreadyAssigned': ' - Déjà assigné',
  'detail.sidebar.assign': 'Assigner',
  'detail.sidebar.assignCount': 'Assigner ({count})',
  'detail.sidebar.cancel': 'Annuler',
  'detail.sidebar.historicalIntelligence': 'Intelligence Historique',
  'detail.sidebar.keyInformation': 'Informations Clés',
  'detail.sidebar.fundingAmount': 'Montant du Financement',
  'detail.sidebar.region': 'Région',
  'detail.sidebar.fundingType': 'Type de Financement',
  'detail.sidebar.sectors': 'Secteurs',
  'detail.sidebar.targetDemographics': 'Démographie Cible',
  'detail.sidebar.recurrence': 'Récurrence',
  'detail.sidebar.targetAudience': 'Public Cible',
  'detail.sidebar.deadline': 'Date Limite',

  // Hero card actions
  'detail.actions.save': 'Sauvegarder',
  'detail.actions.saved': 'Sauvegardé',
  'detail.actions.apply': 'Postuler',
  'detail.actions.share': 'Partager',
  'detail.actions.linkCopied': 'Lien copié dans le presse-papier',
  'detail.actions.savingComingSoon': 'Fonctionnalité de sauvegarde bientôt disponible',

  // Messages and notifications
  'detail.messages.selectProfile': 'Veuillez sélectionner au moins un profil à assigner',
  'detail.messages.assignSuccess': 'Subvention assignée à {count} profil',
  'detail.messages.assignSuccessPlural': 'Subvention assignée à {count} profils',
  'detail.messages.assignFailed': 'Échec de l\'assignation de la subvention aux profils',
  'detail.messages.removeSuccess': 'Assignation du profil supprimée',
  'detail.messages.removeFailed': 'Échec de la suppression de l\'assignation',

  // Application section
  'detail.application.accessPagePrompt': 'Cliquez ci-dessous pour accéder à la page de candidature officielle ou en savoir plus sur cette subvention.',
  'detail.application.goToPage': 'Accéder à la Page de Candidature',
  'detail.application.notAvailable': 'Informations de candidature non disponibles',

  // Geographic display
  'detail.geographic.nationalFrance': 'National (France)',
  'detail.geographic.moreRegions': '+{count} de plus',

  // Recurrence values
  'detail.recurrence.permanent': 'Permanent',
  'detail.recurrence.annual': 'Annuel',
  'detail.recurrence.biannual': 'Bisannuel',
  'detail.recurrence.monthly': 'Mensuel',
  'detail.recurrence.quarterly': 'Trimestriel',
  'detail.recurrence.oneTime': 'Ponctuel',
  'detail.recurrence.ongoing': 'En cours',
  'detail.recurrence.punctual': 'Ponctuel',
  'detail.recurrence.permanente': 'Permanent',
  'detail.recurrence.unknown': 'Non spécifié',

  // Fallback values for missing data
  'detail.fallback.general': 'Général',
  'detail.fallback.financialAid': 'Aide financière',
  'detail.fallback.allRegions': 'Toutes les régions',
  'detail.fallback.more': ' de plus',

  // Documents section
  'detail.documents.requiredDocuments': 'Documents Requis',
  'detail.documents.applicationForm': 'Formulaire de Candidature',
  'detail.documents.onlineApplicationForm': 'Formulaire de candidature en ligne ou portail',
  'detail.documents.required': 'Requis',
  'detail.documents.type.form': 'Formulaire',
  'detail.documents.type.legal': 'Légal',
  'detail.documents.type.reference': 'Référence',
  'detail.documents.type.application': 'Candidature',
  'detail.documents.type.document': 'Document',
  'detail.documents.open': 'Ouvrir',
  'detail.documents.additionalResources': 'Ressources Additionnelles',
  'detail.documents.officialSubsidyPage': 'Page Officielle du Dispositif',
  'detail.documents.originalSource': 'Source d\'information originale de la subvention',
  'detail.documents.view': 'Voir',
  'detail.documents.summary': 'Résumé des Documents',
  'detail.documents.summaryText': '{required} documents requis, {additional} ressources additionnelles',
  'detail.documents.tip': 'Téléchargez et examinez tous les documents requis avant de commencer votre candidature',
  'detail.documents.legalReferences': 'Références Légales',
  'detail.documents.legalFramework': 'Cadre juridique et réglementations officiels',
  'detail.documents.noRequiredDocuments': 'Aucun document requis spécifié',
  'detail.documents.contactForRequirements': 'Contactez l\'organisme pour connaître les documents à fournir',

  // Intelligence Insights section
  'detail.intelligence.createProfile': 'Créez un profil pour voir des informations personnalisées et des prédictions de succès.',
  'detail.intelligence.successPrediction': 'Prédiction de Succès',
  'detail.intelligence.aiAnalysis': 'Analyse IA de votre potentiel de candidature',
  'detail.intelligence.successProbability': 'Probabilité de Succès',
  'detail.intelligence.eligibilityScore': 'Score d\'Éligibilité',
  'detail.intelligence.timeToApply': 'Temps pour Postuler',
  'detail.intelligence.days': 'jours',
  'detail.intelligence.requiredPreparation': 'Préparation Requise',
  'detail.intelligence.riskFactors': 'Facteurs de Risque',
  'detail.intelligence.marketIntelligence': 'Intelligence de Marché',
  'detail.intelligence.competitiveLandscape': 'Paysage concurrentiel et informations du marché',
  'detail.intelligence.applicationVolume': 'Volume de Candidatures',
  'detail.intelligence.averageApplications': 'Candidatures moyennes',
  'detail.intelligence.competitionTrend': 'Tendance de la Concurrence',
  'detail.intelligence.increasing': 'En augmentation',
  'detail.intelligence.stable': 'Stable',
  'detail.intelligence.averageAward': 'Montant Moyen',
  'detail.intelligence.historicalSuccessRate': 'Taux de Succès Historique',
  'detail.intelligence.marketInsights': 'Informations du Marché',
  'detail.intelligence.smartActions': 'Actions Intelligentes',
  'detail.intelligence.saveToFavorites': 'Enregistrer dans les Favoris',
  'detail.intelligence.setReminder': 'Définir un Rappel',
  'detail.intelligence.compareSimilar': 'Comparer des Similaires',
  'detail.intelligence.startApplication': 'Commencer la Candidature',

  // Section titles
  'detail.requirements.title': 'Exigences de Candidature',
  'detail.process.title': 'Processus de Candidature',
  'detail.legal.title': 'Cadre Juridique',
  'detail.administrative.title': 'Détails Administratifs',

  // Application Requirements section
  'detail.requirements.notAvailable': 'Détails du processus de candidature non disponibles',
  'detail.requirements.contactForInstructions': 'Contactez l\'organisme pour les instructions de candidature',
  'detail.requirements.applyOnline': 'Postuler en Ligne',
  'detail.requirements.accessPortal': 'Accédez au portail de candidature officiel pour soumettre votre demande.',
  'detail.requirements.goToPortal': 'Accéder au Portail de Candidature',
  'detail.requirements.timelineTitle': 'Calendrier et Dates Importantes',
  'detail.requirements.applicationDeadline': 'Date Limite de Candidature',
  'detail.requirements.finalDate': 'Date finale pour soumettre votre candidature',
  'detail.requirements.predepositDate': 'Date de Pré-dépôt',
  'detail.requirements.earlySubmission': 'Soumission anticipée ou déclaration d\'intention',
  'detail.requirements.periodOpens': 'Ouverture de la Période de Candidature',
  'detail.requirements.whenAccepted': 'Quand les candidatures commencent à être acceptées',
  'detail.requirements.periodCloses': 'Fermeture de la Période de Candidature',
  'detail.requirements.lastDay': 'Dernier jour pour soumettre les candidatures',
  'detail.requirements.projectStartDate': 'Date de Début du Projet',
  'detail.requirements.whenBegin': 'Quand les projets financés devraient commencer',
  'detail.requirements.fundingPeriod': 'Période de Financement',
  'detail.requirements.durationAvailability': 'Durée de disponibilité du financement',
  'detail.requirements.generalDeadline': 'Date Limite Générale',
  'detail.requirements.importantDate': 'Date importante à retenir',

  // Administrative Details section
  'detail.administrative.primaryAgency': 'Organisme Administratif Principal',
  'detail.administrative.implementingOrg': 'Organisation de Mise en Œuvre',
  'detail.administrative.fundingEntity': 'Entité de Financement',
  'detail.administrative.technicalInstructor': 'Instructeur Technique',
  'detail.administrative.complianceRequirements': 'Exigences de Conformité',
  'detail.administrative.reportingRequirements': 'Exigences de Rapport',
  'detail.administrative.evaluationCriteria': 'Critères d\'Évaluation',
  'detail.administrative.applicationOpens': 'Ouverture des Candidatures',
  'detail.administrative.predepositDeadline': 'Date Limite de Pré-dépôt',
  'detail.administrative.applicationDeadline': 'Date Limite de Candidature',
  'detail.administrative.projectDuration': 'Durée du Projet',
  'detail.administrative.notAvailable': 'Détails administratifs non disponibles',
  'detail.administrative.contactForGuidance': 'Contactez l\'organisme pour des conseils administratifs',
  'detail.administrative.structure': 'Structure Administrative',
  'detail.administrative.contactDirectory': 'Répertoire de Contact',
  'detail.administrative.primaryContact': 'Contact Principal',
  'detail.administrative.visitWebsite': 'Visiter le Site Web',
  'detail.administrative.additionalContacts': 'Contacts Supplémentaires',
  'detail.administrative.technicalSupport': 'Support Technique',
  'detail.administrative.expertise': 'Expertise : ',
  'detail.administrative.timeline': 'Calendrier Administratif',
  'detail.administrative.compliance': 'Conformité et Exigences',
  'detail.administrative.mandatory': 'Obligatoire',
  'detail.administrative.recommended': 'Recommandé',

  // Legal Framework section
  'detail.legal.primaryAgency': 'Organisme Principal',
  'detail.legal.administeringOrg': 'Organisation Gestionnaire',
  'detail.legal.instructorOrg': 'Organisation Instructrice',
  'detail.legal.notAvailable': 'Informations sur le cadre juridique non disponibles',
  'detail.legal.contactForDetails': 'Contactez l\'organisme pour les détails réglementaires',
  'detail.legal.aidClassification': 'Classification de l\'Aide',
  'detail.legal.regulations': 'Réglementations : ',
  'detail.legal.legalBasis': 'Base Juridique',
  'detail.legal.administeringOrganizations': 'Organisations Gestionnaires',
  'detail.legal.regulatoryRequirements': 'Exigences Réglementaires',
  'detail.legal.termsAndConditions': 'Conditions Générales',
  'detail.legal.officialDocumentation': 'Documentation Juridique Officielle',
  'detail.legal.viewFramework': 'Consultez le cadre juridique complet et les réglementations régissant cette subvention.',
  'detail.legal.accessReferences': 'Accéder aux Références Juridiques',

  // Process Workflow section
  'detail.process.notAvailable': 'Processus de candidature détaillé non disponible',
  'detail.process.contactForGuidance': 'Contactez l\'organisme pour un accompagnement étape par étape',
  'detail.process.applicationWorkflow': 'Étapes de Candidature',
  'detail.process.mobilizationWorkflow': 'Étapes de Mobilisation',
  'detail.process.mobilizationDescription': 'Étapes pour activer et utiliser votre financement une fois approuvé :',
  'detail.process.documentChecklist': 'Liste des Documents',
  'detail.process.documentChecklistDescription': 'Assurez-vous d\'avoir tous les documents requis avant de commencer votre candidature :',
  'detail.process.requirements': 'Prérequis',
  'detail.process.responsible': 'Responsable :',
  'detail.process.documentTip': 'Astuce : Cochez les documents au fur et à mesure de leur préparation pour suivre votre progression',

  // Report Missing Subsidy dialog
  'report.missing.button': 'Signaler un dispositif manquant',
  'report.missing.buttonShort': 'Signaler',
  'report.missing.buttonMobile': 'Signaler',
  'report.missing.title': 'Signaler un dispositif manquant',
  'report.missing.description': 'Vous connaissez une subvention qui n\'est pas dans notre base de données ? Faites-le nous savoir et nous l\'ajouterons !',
  'report.missing.name': 'Nom de la subvention',
  'report.missing.name.required': 'Le nom de la subvention est requis',
  'report.missing.name.placeholder': 'ex. MaPrimeRénov\' 2025',
  'report.missing.url': 'URL de la subvention',
  'report.missing.url.required': 'L\'URL de la subvention est requise',
  'report.missing.url.invalid': 'Veuillez entrer une URL valide (commençant par http:// ou https://)',
  'report.missing.url.placeholder': 'https://...',
  'report.missing.url.help': 'Où avez-vous trouvé cette subvention ? (site officiel, page gouvernementale, etc.)',
  'report.missing.message': 'Informations supplémentaires (Optionnel)',
  'report.missing.message.placeholder': 'Tout contexte supplémentaire sur cette subvention (éligibilité, montants, échéances, etc.)',
  'report.missing.email': 'Votre email (Optionnel)',
  'report.missing.email.placeholder': 'votre.email@exemple.fr',
  'report.missing.email.help': 'Si vous souhaitez être notifié lorsque nous ajoutons cette subvention',
  'report.missing.alert': 'Notre équipe examinera votre soumission et ajoutera la subvention à notre base de données si elle est valide et pertinente.',
  'report.missing.cancel': 'Annuler',
  'report.missing.submit': 'Envoyer le signalement',
  'report.missing.submitting': 'Envoi en cours...',
  'report.missing.success': 'Signalement envoyé avec succès ! Nous examinerons et ajouterons bientôt cette subvention.',
  'report.missing.toast.success': 'Signalement envoyé !',
  'report.missing.toast.success.description': 'Merci de nous aider à améliorer notre base de données. Nous examinerons bientôt cette subvention.',
  'report.missing.toast.error': 'Échec de l\'envoi',
  'report.missing.toast.error.description': 'Veuillez réessayer plus tard.',

  // Flag mismatch reporting
  'flag.button': 'Signaler un problème',
  'flag.button.tooltip': 'Cette subvention ne correspond pas à votre profil ?',
  'flag.title': 'Signaler un problème de correspondance',
  'flag.description': 'Aidez-nous à améliorer notre algorithme en nous indiquant pourquoi cette subvention ne correspond pas à votre profil.',
  'flag.subtitle': 'Subvention concernée',
  'flag.reason.label': 'Pourquoi cette subvention ne correspond-elle pas ?',
  'flag.reason.placeholder': 'Sélectionnez une raison...',
  'flag.reason.required': 'Veuillez sélectionner une raison',
  'flag.additionalReasons.label': 'Autres problèmes (optionnel)',
  'flag.explanation.label': 'Explication détaillée (optionnel)',
  'flag.explanation.placeholder': 'Décrivez le problème en détail pour nous aider à améliorer notre algorithme...',
  'flag.severity.label': 'Gravité du problème',
  'flag.severity.low': 'Mineur',
  'flag.severity.low.description': 'Légèrement hors sujet',
  'flag.severity.medium': 'Modéré',
  'flag.severity.medium.description': 'Ne correspond pas vraiment',
  'flag.severity.high': 'Important',
  'flag.severity.high.description': 'Complètement hors sujet',
  'flag.severity.critical': 'Critique',
  'flag.severity.critical.description': 'Erreur majeure',
  'flag.cancel': 'Annuler',
  'flag.submit': 'Envoyer le signalement',
  'flag.submitting': 'Envoi en cours...',
  'flag.success': 'Signalement envoyé avec succès ! Nous analyserons ce problème pour améliorer notre algorithme.',
  'flag.toast.success': 'Merci pour votre signalement !',
  'flag.toast.success.description': 'Votre feedback nous aide à améliorer la pertinence des résultats.',
  'flag.toast.error': 'Échec de l\'envoi',
  'flag.toast.error.description': 'Veuillez réessayer plus tard.',
  'flag.info': 'Votre signalement sera analysé par notre IA pour améliorer automatiquement la correspondance des subventions.',

  // Flag reasons
  'flag.reason.geography_match': 'Mauvaise région',
  'flag.reason.sector_match': 'Mauvais secteur d\'activité',
  'flag.reason.amount_fit': 'Montant inadapté',
  'flag.reason.target_audience': 'Pas mon type d\'entreprise',
  'flag.reason.legal_entity': 'Forme juridique incorrecte',
  'flag.reason.naf_code_match': 'Code NAF non compatible',
  'flag.reason.expired_deadline': 'Date limite dépassée',
  'flag.reason.wrong_amount': 'Montant affiché incorrect',
  'flag.reason.duplicate': 'Doublon d\'une autre subvention',
  'flag.reason.other': 'Autre raison',

  // Error Boundary - Subsidy Detail
  'error.unableToLoadSubsidy': 'Impossible de Charger les Détails de la Subvention',
  'error.loadingError': 'Une erreur s\'est produite lors du chargement des informations de la subvention. Cela peut être dû à un problème temporaire ou la subvention n\'est peut-être plus disponible.',
  'error.tryAgain': 'Réessayer',
  'error.backToSearch': 'Retour à la Recherche',
  'error.contactSupport': 'Contacter le Support',
  'error.subsidyId': 'ID de la subvention',

  // Error Boundary - General
  'error.somethingWentWrong': 'Une erreur s\'est produite',
  'error.formErrorDetected': 'Erreur de Formulaire Détectée',
  'error.formComponentError': 'Une erreur de composant de formulaire s\'est produite lors du traitement de votre demande.',
  'error.typicallyHappensWhen': 'Cela se produit généralement lorsque :',
  'error.documentImportFail': 'L\'import de document ne parvient pas à remplir tous les champs requis',
  'error.invalidDataDropdowns': 'Des données invalides sont chargées dans les menus déroulants',
  'error.networkInterrupt': 'Des problèmes réseau interrompent le chargement du formulaire',
  'error.unexpectedError': 'Une erreur inattendue s\'est produite. Nous nous excusons pour la gêne occasionnée.',
  'error.technicalDetails': 'Détails Techniques :',
  'error.copy': 'Copier',
  'error.goHome': 'Accueil',
  'error.formErrorPersists': 'Si cette erreur persiste, essayez de remplir manuellement les champs du formulaire ou contactez notre équipe d\'assistance.',
  'error.keepHappening': 'Si cela continue, veuillez contacter notre équipe pour une assistance directe :',
  'error.copied': 'Copié',
  'error.errorDetailsCopied': 'Détails de l\'erreur copiés dans le presse-papier',
} as const;
